import gql from 'graphql-tag';
import * as types from 'DailyDietPlan/DayPlanTypes';

const query = gql`
    query FavoriteMeals($date: Date!, $text: String) {
        me {
            id
            diet {
                dietId: id
                availableDays {
                    date
                }
            }
            dailyDietPlan(date: $date) {
                ... on ${types.DAY_PLAN} {
                    dayDiet {
                        phase {
                            name
                            colour
                        }
                    }
                }
            }
            favoriteMeals(text: $text) {
                id
                kcal
                macro {
                    protein {
                        grams
                        kcal
                        percentage
                    }
                    animalProtein {
                        grams
                        kcal
                        percentage
                    }
                    fat {
                        grams
                        kcal
                        percentage
                    }
                    carbohydrates {
                        grams
                        kcal
                        percentage
                    }
                }
                preparationTime {
                    years
                    months
                    days
                    hours
                    minutes
                    seconds
                }
                dishes {
                    id
                    name
                    recipe
                    ingredients {
                        productAmountId
                        productId
                        name
                        category {
                            id
                            isSeasoning
                            isOptional
                            name
                        }
                        measurements {
                            amount
                            unit
                            text
                        }
                        saleProductVariant {
                            link
                        }
                    }
                    triangleOfPower {
                        body
                        mind
                        libido
                    }
                }
                preparationVideoUrl
                preparationImageUrl
                publicName
                name
                dietId
                mealType
                phase {
                    identifier
                    name
                    colour
                }
            }
        }
    }
`;

export default query;
